
import { Mixins, Component, Prop, VModel } from 'vue-property-decorator'
import { openDialog } from '@/_components/dialog/dialog'

import LocationDrawingDialog from '../dialogs/locationDrawing.vue'
import LocationDrawing from '../components/locationDrawing.vue'

@Component({
    name: 'LocationDrawingChip',
    components: { LocationDrawingDialog, LocationDrawing },
})
export default class LocationDrawingChip extends Mixins() {
    @VModel() observation!: any
    @Prop({ default: true }) disabled!: any

    async selectLocationDrawing() {
        const drawingInfo = await openDialog(LocationDrawingDialog, {
            observation: this.observation,
            projectId: this.observation?.project?.data?.id,
            disabled: this.disabled,
        })

        if (drawingInfo) {
            Object.keys(drawingInfo).forEach((key) => {
                this.observation[key] = drawingInfo[key]
            })
        }
    }

    removeLocationDrawing() {
        this.observation.locationDrawing.data = null
        this.observation.locationDrawingX = null
        this.observation.locationDrawingY = null
    }
}
